import { render, staticRenderFns } from "./register_patient.vue?vue&type=template&id=6324577e&scoped=true&"
import script from "./register_patient.vue?vue&type=script&lang=js&"
export * from "./register_patient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6324577e",
  null
  
)

export default component.exports